export default function NoAccessModal() {
  return (
    <div className="modal fade" id="no-access-modal" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0 justify-content-end">
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <p className='subhead-3 text-primary mb-2 lh-sm'>These Prime Perks require access to your online Rewards to be redeemed.</p>
            <p className="mb-4">Please link your Wind Creek Rewards Account to a new online account in order to view your online Rewards.</p>
            <p className='subhead-3 text-primary mb-2 lh-sm'>Already have an online account?</p>
            <p className="mb-0">Simply sign out of your Rewards Account and sign back in using the email address and password associated with your online account.</p>
          </div>
          <div className="modal-footer border-0 pt-0">
            <div className="d-none" hidden data-signed-in="true">
              <button type="button" className="btn btn-outline-primary fs-sm" data-sign-out>
                <span>Sign Out</span>
              </button>
            </div>
            <a href="https://windcreekcasino.com/signup" target="_blank" className="btn btn-primary fs-sm">Join Now</a>
          </div>
        </div>
      </div>
    </div>
  );
}
